import { render, staticRenderFns } from "./SettingForm.vue?vue&type=template&id=5528aca6&"
import script from "./SettingForm.vue?vue&type=script&lang=js&"
export * from "./SettingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports